export const CartModuleConsts = {
    CART_PAGE_TITLE: 'World of Sweets - My Cart',
    ORDER_CONFIRMATION_PAGE_TITLE: 'World of Sweets - My Cart',
    PAYMENT_PAGE_TITLE: 'World of Sweets - Cart Payment',
    ORDER_SUMMARY:'World of Sweets - Order Summary',
    REMOVEPOPUPMESSAGE:'Are you sure you want to remove product from cart?',
    BI_TRACKING_IDENTIFIER_TOREMOVE: 3,
    BI_TRACKING_IDENTIFIER_TOPLACEORDER: 4,
    PREPROD: 'preprod'
}